import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  TextConsentsDialog,
  TextConsentsDialogCallbackInput,
  TextConsentsDialogUniqueProps,
} from '../message/text-consents-dialog';

const { useDialogForContext, useDialog: useTextConsentsDialog } =
  getDialogHooks<
    TextConsentsDialogUniqueProps,
    TextConsentsDialogCallbackInput
  >(TextConsentsDialog);

export const useTextConsentsDialogForContext = useDialogForContext;
export default useTextConsentsDialog;
